import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=1b608d9c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b608d9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b608d9c')) {
      api.createRecord('1b608d9c', component.options)
    } else {
      api.reload('1b608d9c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=1b608d9c&scoped=true&", function () {
      api.rerender('1b608d9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qc23xah3NoK0/JS/comp/Accordion.vue"
export default component.exports